import { USPS } from "../data";

export default function Marquee() {
  const items = [...USPS, ...USPS]; // duplicate for seamless scroll
  return (
    <section
      data-testid="usp-marquee"
      aria-label="Our promises"
      className="border-y border-white/5 bg-[#0A0C10] py-6 overflow-hidden relative"
    >
      <div className="flex w-max animate-marquee gap-14">
        {items.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-5 whitespace-nowrap"
          >
            <span className="font-heading text-xl sm:text-2xl lg:text-3xl text-white/80 tracking-tight">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
          </div>
        ))}
      </div>
    </section>
  );
}
